import React from 'react'
import useUsers from '../../../hooks/use-users'
import useUsersFilters from '../../../hooks/use-users-filters'
import { Row, Col, Spinner } from 'react-bootstrap'
import RecordPagination from '../../common/pagination'

const UsersListPaginated = ({
    pageSize = 18,
    userComponent
}) => {
    const {
        isLoading,
        users,
        total
    } = useUsers({ limit: pageSize })
    const { offset, updateFilters } = useUsersFilters()
    const UserComponent = userComponent
    return (
        <React.Fragment>
            <Row>
                <Col className='text-center'>
                    &nbsp;{isLoading && <Spinner animation="border" size="sm" />}&nbsp;
                </Col>
            </Row>
            <Row noGutters>
                {users.map( u => <UserComponent key={u.id} user={u}/>)}
                {!isLoading && !total && <Col className='text-muted text-center'>There are no users</Col>}
            </Row>
            <Row>
                <Col>
                    <RecordPagination
                        offset={offset}
                        limit={pageSize}
                        total={total}
                        setOffset={offset => updateFilters({ offset })}
                    />
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default UsersListPaginated